export enum TimelineEventSeverityStoreModelEnum {
  Normal = 'NORMAL',
  Warning = 'WARNING',
  Alert = 'ALERT',
}

export enum TimelineTypeStoreModelEnum {
  AdaptivePowerCapChangeEvent = 'adaptive-power-cap-change',
  AuthorizationFailedEvent = 'authorization-failed',
  AuthorizationSuccessfulEvent = 'authorization-successful',
  BootNotificationEvent = 'boot-notification',
  ChargingFaultedEvent = 'charging-faulted',
  CsFaultedEvent = 'cs-faulted',
  EvseFaultedEvent = 'evse-faulted',
  CsStateChangeEvent = 'cs-state-change',
  CustomCommandEvent = 'custom-command',
  ForceDisconnectEvent = 'force-disconnect',
  HardResetEvent = 'hard-reset',
  SoftResetEvent = 'soft-reset',
  PowerLimitChangeEvent = 'power-limit-change',
  PowerLimitChangeRejectedEvent = 'power-limit-change-rejected',
  PowerOverrideClearedEvent = 'power-override-cleared',
  ManualPrioritySetEvent = 'manual-priority-set',
  ManualPriorityClearedEvent = 'manual-priority-cleared',
  StatusNotificationEvent = 'status-notification',
  SessionClosedEvent = 'session-closed',
  SessionOpenedEvent = 'session-opened',
  TransactionBlockedEvent = 'transaction-blocked',
  TransactionStartedEvent = 'transaction-started',
  TransactionRemoteStartEvent = 'transaction-remote-start',
  TransactionStoppedEvent = 'transaction-stopped',
  TransactionRemoteStopEvent = 'transaction-remote-stop',
  TriggerMessageEvent = 'trigger-message',
  UnlockConnectorEvent = 'unlock-connector',
  UnknownVehiclePluggedInEvent = 'unknown-vehicle-plugged-in',
  UnrecognizableOcppMessageEvent = 'unrecognizable-ocpp-message',
  VehiclePluggedInEvent = 'vehicle-plugged-in',
  VehicleUnpluggedEvent = 'vehicle-unplugged',
}

export enum TransactionStopSourceStoreModelEnum {
  Charger = 'CHARGER',
  Ems = 'EMS', // minpower?
  Be = 'BE', // user command?
  Lc = 'LC', // issued from LC ...  maintenance?
}

export enum ChargerCommandTypeStoreModelEnum {
  HardReset = 'hard-reset',
  SoftReset = 'soft-reset',
  ForceDisconnect = 'force-disconnect',
}

export enum EvseCommandTypeStoreModelEnum {
  RemoteStart = 'remote-start',
  RemoteStop = 'remote-stop',
  PowerLimitChange = 'power-limit-change',
  PowerLimitClear = 'power-limit-clear',
  UnlockConnector = 'unlock-connector',
  TriggerMeterValues = 'trigger-meter-values',
  TriggerStatusNotification = 'trigger-status-notification',
}

export enum ConfigurationChangeStatusStoreModelEnum {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  RebootRequired = 'REBOOT_REQUIRED',
  NotSupported = 'NOT_SUPPORTED',
  Failed = 'FAILED',
}
